import React from 'react'
import { Box, Grid, Chip, Typography } from '@mui/material'
import { TicketInfo } from '../../../interfaces/PickingValidate/TicketInfo'
import { useStyles } from './styles'
import { StatesRoutes } from '../../../interfaces/PickingValidate/StatesRoutes'
import { PickingValidateHeader } from '../../../interfaces/Picking/Picking'
import { PickingRouteMissingPieces } from './PickingRouteMissingPieces'
import { eTypePickingRoute } from '../../../enums/eTypePickingRoute'
import { fechaFormateada } from '../../../utils/dateHelper'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'

interface PickingFinishHeaderProps {
  ticketInfo: TicketInfo
  statesRoute: StatesRoutes
  pickingHeader: PickingValidateHeader | undefined
}

export const PickingFinishHeaderVas: React.FC<PickingFinishHeaderProps> = ({
  ticketInfo,
  statesRoute,
  pickingHeader
}) => {
  const classes = useStyles()

  const missingUnitsQty =
    (pickingHeader?.realQty || 0) - (pickingHeader?.pickedQty || 0)

  return (
    <Box className={classes.productInfoHeader}>
      <Grid container spacing={2}>
        {/* Fila 1 */}
        <Grid item xs={12} sm={6} md={3}>
          <Typography variant='caption' color='textSecondary' display='block'>
            Ruta de picking
          </Typography>
          <Typography variant='body1' style={{ fontWeight: 600 }}>
            {pickingHeader?.typePickingRouteId === eTypePickingRoute.RTV
              ? `RTV${pickingHeader.pickingRouteId}`
              : pickingHeader?.pickingRouteId}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Typography variant='caption' color='textSecondary' display='block'>
            Tag OT
          </Typography>
          <Typography variant='body1' style={{ fontWeight: 600 }}>
            {ticketInfo.workOrderTag}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Typography variant='caption' color='textSecondary' display='block'>
            OT
          </Typography>
          <Typography variant='body1' style={{ fontWeight: 600 }}>
            {pickingHeader?.typePickingRouteId === eTypePickingRoute.RTV
              ? `RTV${ticketInfo.workOrderId}`
              : ticketInfo.workOrderId}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Typography variant='caption' color='textSecondary' display='block'>
            ID de Pedido
          </Typography>
          <Typography variant='body1' style={{ fontWeight: 600 }}>
            {pickingHeader?.skuDetail?.[0]?.referenceId || '-'}
          </Typography>
        </Grid>

        {/* Fila 2 */}
        <Grid item xs={12} sm={6} md={3}>
          <Typography variant='caption' color='textSecondary' display='block'>
            LPN
          </Typography>
          <Typography variant='body2'>
            {pickingHeader?.lpn === null ? (
              <Box display='flex' alignItems='center'>
                <RemoveCircleOutlineIcon
                  fontSize='small'
                  style={{ marginRight: 4 }}
                />
                Sin LPN
              </Box>
            ) : (
              pickingHeader?.lpn
            )}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Typography variant='caption' color='textSecondary' display='block'>
            Zona
          </Typography>
          <Typography variant='body2'>{ticketInfo.zone}</Typography>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Typography variant='caption' color='textSecondary' display='block'>
            Estado de la ruta
          </Typography>
          <Chip
            label={
              statesRoute.pickingRouteState === 'CREADA'
                ? 'NO INICIADA'
                : statesRoute.pickingRouteState
            }
            style={{
              backgroundColor: statesRoute.colorPickingRouteState,
              color: '#fff',
              fontWeight: 600,
              marginTop: 4
            }}
            size='small'
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Typography variant='caption' color='textSecondary' display='block'>
            Observaciones
          </Typography>
          <Typography variant='body2'>
            {pickingHeader?.orderCancellationRequest ? (
              <strong style={{ color: 'red' }}>SOLICITUD DE CANCELACIÓN</strong>
            ) : (
              <PickingRouteMissingPieces quantity={missingUnitsQty} />
            )}
          </Typography>
        </Grid>

        {/* Fila 3 */}
        <Grid item xs={12} sm={6} md={3}>
          <Typography variant='caption' color='textSecondary' display='block'>
            Fecha validación
          </Typography>
          <Typography variant='body2'>
            {fechaFormateada(
              pickingHeader?.validationendedAt,
              'dd/MM/yyyy hh:mm a'
            )}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Typography variant='caption' color='textSecondary' display='block'>
            Validado por
          </Typography>
          <Typography variant='body2'>
            {pickingHeader?.validationUser}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  )
}
